module.exports = __webpack_public_path__ + "img/card-bg-dark.33a6163a.jpg";